import { render } from "./BitkubError.vue?vue&type=template&id=7ec95fda&scoped=true"
import script from "./BitkubError.vue?vue&type=script&lang=js"
export * from "./BitkubError.vue?vue&type=script&lang=js"

import "./BitkubError.vue?vue&type=style&index=0&id=7ec95fda&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec95fda"]])

export default __exports__